import React from 'react';
import SidebarWithHeader from './SidebarWithHeader';

function index({ children, style }) {
  return <SidebarWithHeader style={style} children={children} />;
}

export default index;
